import * as types from 'misc/types';
import * as actions from 'misc/actions';

const search_results = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_ARCHIVES_SEARCH_GET.REQUEST:
            return actions.load(state);
        case types.SAGA_ARCHIVES_SEARCH_GET.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_ARCHIVES_SEARCH_GET.FAILURE:
            return actions.error(state, action.error);

        case types.ARCHIVES_SEARCH_CLEAR:
            return actions.save(state, []);

        default:
            return state;
    }
};

export default search_results;



// WEBPACK FOOTER //
// ./src/reducers/search_results.js